(() => {
  if (window.__prestigeProductCardHoverLoader) return;
  window.__prestigeProductCardHoverLoader = true;

  const script = document.currentScript;
  const moduleUrl = script?.dataset.productCardHoverModule;

  if (!moduleUrl) return;

  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  let modulePromise = null;
  let api = null;

  const isConstrainedConnection = () =>
    Boolean(connection?.saveData) || ['slow-2g', '2g'].includes(connection?.effectiveType);

  const canEnhance = () =>
    hoverQuery.matches && !reducedMotionQuery.matches && !isConstrainedConnection() && !document.hidden;

  const loadModule = () => {
    if (api) return Promise.resolve(api);
    if (modulePromise) return modulePromise;

    modulePromise = import(moduleUrl)
      .then((module) => {
        api = module;
        return module;
      })
      .catch(() => {
        modulePromise = null;
        return null;
      });

    return modulePromise;
  };

  document.addEventListener(
    'pointerover',
    (event) => {
      const card = event.target.closest?.('product-card[data-product-card-hover-slideshow]');

      if (!card || card.contains(event.relatedTarget) || !canEnhance()) return;

      card.setAttribute('data-product-card-hover-enhancing', '');

      loadModule().then((module) => {
        if (!module || !card.isConnected || !card.matches(':hover') || !canEnhance()) {
          card.removeAttribute('data-product-card-hover-enhancing');
          return;
        }

        module.start(card);
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    (event) => {
      const card = event.target.closest?.('product-card[data-product-card-hover-slideshow]');

      if (!card || card.contains(event.relatedTarget)) return;

      if (api) {
        api.stop(card);
      } else {
        card.removeAttribute('data-product-card-hover-enhancing');
      }
    },
    { passive: true }
  );

  const stopForCapabilityChange = () => {
    if (canEnhance()) return;
    api?.stopAll({ instant: true });
  };

  hoverQuery.addEventListener('change', stopForCapabilityChange);
  reducedMotionQuery.addEventListener('change', stopForCapabilityChange);
  connection?.addEventListener?.('change', stopForCapabilityChange);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) api?.stopAll({ instant: true });
  });

  document.addEventListener('shopify:section:unload', (event) => {
    api?.stopWithin(event.target);
  });
})();
